module.exports = "https://static.zego.com/_next/static/images/social-freenow-17ba0c3018604d0321f8ed23624820cd.jpg";